import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export var StorageSharedKeyCredential = function StorageSharedKeyCredential() {
  _classCallCheck(this, StorageSharedKeyCredential);
};